<template>
  <mini-card :value="'$'+totalPaidPayouts" subtitle="Paid" :previousValue="'$'+totalPaidPayoutsPrevious">
    <div slot="header" class="icon-warning">
      <i class="fad fa-sack-dollar text-primary"></i>
    </div>
    <template slot="footer">
      <div class="row small ml-0">
        <span><i class="far fa-clock mr-2"/>Last payment: &nbsp;<i>2020-04-01</i></span>
      </div>
    </template>
  </mini-card>
</template>

<script>
import {Payout} from 'src/classes/datamodel.js'
import MiniCard from './MiniCard.vue'
export default {
  name: 'Payouts-Paid-MiniCard',
  components: {
    MiniCard
  },
  methods: {
    managePayouts () {
      alert('Feature coming soon!')
    },
    addPayout () {
      this.$store.dispatch('openModal', {name: 'Payout', mode: 'Create', object: new Payout({})})
    }
  },
  computed: {
    totalPaidPayouts () {
      return this.$store.getters.totalPayouts({status: Payout._status.PAID})
    },
    totalPaidPayoutsPrevious () {
      return this.$store.getters.totalPayoutsPrevious({status: Payout._status.PAID})
    }
  }
}
</script>

<style>

</style>